import React, { useEffect, useState, useRef, useCallback } from 'react'
import {ChatItem, MessageList, Popup, Input, Button } from 'react-chat-elements';
import AutoLinkText from 'react-autolink-text2';
import {useDropzone} from 'react-dropzone'

import 'react-chat-elements/dist/main.css';
import styled from 'styled-components'
import Frisbee from 'frisbee'

import { FaAlignJustify, FaChevronDown, FaChevronUp, FaCloudUploadAlt } from 'react-icons/fa';

function FileUploadButton(props) {
  const onDrop = useCallback(props.onDrop, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, accept: "image/jpeg,image/png,.xls,.xlsx,.doc,.docx,.pdf,.pptx"})

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <FaCloudUploadAlt className="rce-input-button-left"/>
    </div>
  )
}

const api = new Frisbee({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const postApi = new Frisbee({
  headers: {
    credentials: "include"
  },
})

function App(props) {
  const [messages, setMessages] = useState([]);
  const [recentId, setRecentId] = useState();
  const [pastId, setPastId] = useState();
  const [hasRecentMessage, setHasRecentMessage] = useState(true);
  const [hasPastMessage, setHasPastMessage] = useState(false);
  const [sendButtonDisabled, setSendButtonDisabled] = useState(false);
  const inputRef = useRef(null);
  const recentButtonRef = useRef(null);

  return (
    <Container>
      <div className="btn-open-close">
        <FaAlignJustify/>
      </div>
      <Header>
      </Header>
      <Contents>
        <ChatItem
          avatar={'https://facebook.github.io/react/img/logo.svg'}
          alt={'Reactjs'}
          title={'Facebook'}
          subtitle={'What are you doing?'}
          date={new Date()}
          unread={0}
        />
      </Contents>
    </Container>
  )
}

export default App

const Container = styled.div`
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 0 14px 0 rgb(0 0 0 / 12%), 0 6px 6px rgb(0 0 0 / 20%);
  margin: calc(1.5em / 1.5);
  overflow: hidden;

  position: fixed;
  right: 0;
  bottom: 0;
  width: 50vw;
  max-width: 640px;
  height: 80vh;

  display: flex;
  flex-direction: column;
  flex-wrap: no-wrap;

  .btn-open-close {
    position: absolute;
    right: 10px;
    top: 15px;
    width: 40px;
    height: 40px;
    background: #fff;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.05), 0 2px 5px 0 rgba(0,0,0,0.1);
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    cursor: pointer;
    transition: 200ms;
    &:hover {
      opacity: 0.7;
    }
  }
`

const Header = styled.div`
  background-color: #35cce6;
  color: white;

  padding: 0 20px;
  text-align: center;

  h1 {
    font-size: 1.6rem;
    margin: 0.5em auto;
  }
`

const Contents = styled.div`
  background-color: #fafafa;

  flex: 1;
  height: 50vh;
  position: relative;
  
  .rce-container-mlist {
    height: 100%;
  }
  .rce-mlist {
    overscroll-behavior: contain;
  }
  .rce-container-mbox {
    margin: 0.5em 0;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  .rce-mbox {
    max-width: 70%;
  }
  .rce-mbox-body {
    padding-bottom: 12px;
  }
  .rce-mbox-text {
    white-space: pre-wrap;
  }
  .rce-mbox-photo {
    padding-bottom: 13px;
    img {
      cursor: pointer;
    }
    img[src$=image] {
      cursor: default;
    }
    .rce-mbox-text {
      padding: 5px 6px;
      max-width: none;
      margin: auto;
    }
  }
  .rce-mbox-file {
    button {
      color: rgba(0, 0, 0, .45);
    }
    color: rgba(0, 0, 0, .45);
  }
  .rce-mbox-time-block {
    background: none;
    color: rgba(0, 0, 0, .45);
  }
  .rce-mlist-up-button {
    top: 15px;
  }
`

const Tools = styled.div`
  min-height: 1em;
  max-height: 10em;
  overflow: hidden;
  padding: 0 20px;
  .rce-container-input {
    margin: 5px 0;
  }
  .rce-button {
    padding-right: 20px;
    padding-left: 20px;
  }

  background-color: #f4f7f9;
  textarea, .rce-container-input {
    background-color: transparent;
  }
  .rce-button {
    font-weight: normal;
  }
  .rce-input-button-left {
    font-size: 1.4em;
  }
`